import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-100552ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white rounded-4 shadow p-4 mb-5" }
const _hoisted_2 = { class: "fw-bold" }
const _hoisted_3 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7 mt-5" }
const _hoisted_4 = { class: "w-max-content col-lg-3" }
const _hoisted_5 = { class: "col-lg-9" }
const _hoisted_6 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_7 = { class: "w-max-content col-lg-3" }
const _hoisted_8 = { class: "col-lg-9" }
const _hoisted_9 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_10 = { class: "w-max-content col-lg-3" }
const _hoisted_11 = { class: "col-lg-9" }
const _hoisted_12 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_13 = { class: "w-max-content col-lg-3" }
const _hoisted_14 = { class: "col-lg-9" }
const _hoisted_15 = { class: "d-flex justify-content-center" }

import { PropType } from 'vue'
import { useRouter } from 'vue-router'

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import { ConvertFromLocalTime } from '@/constants/datepicker.ts'


export default /*#__PURE__*/_defineComponent({
  props: {
  data: Object as PropType<{
    created_at: string
    employee_community_terms_of_uses: {
      employee_community_terms_of_uses_id: string | number
      version: number | string
      agreement_at: string
    }
    last_login: string
    profile_n_portfolio_published: number
    email_notice: boolean
    available: boolean
  }>,
},
  setup(__props) {

const router = useRouter()


const backToList = () => {
  router.push(`/community/communities/${router.currentRoute.value.params?.id}/community-users?management_no=desc`)
}

const transitTermUse = (version: number | string): void => {
  router.push(`/community/communities/${router.currentRoute.value.params?.id}/terms_of_uses/edit?version_id=${version}&tab=employee`)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(translate)('OE30managementInformation')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", _hoisted_4, _toDisplayString(_unref(translate)('applicationTime')), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(__props.data?.created_at ? _unref(ConvertFromLocalTime)(__props.data?.created_at) : ''), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(translate)('OE31consentDate')), 1),
      _createElementVNode("div", _hoisted_8, [
        _createTextVNode(_toDisplayString(__props.data?.employee_community_terms_of_uses.agreement_at ? _unref(ConvertFromLocalTime)(__props.data?.employee_community_terms_of_uses.agreement_at) : ''), 1),
        _createElementVNode("u", {
          class: "ps-1 cursor-pointer hover-link",
          onClick: _cache[0] || (_cache[0] = () => transitTermUse(__props.data?.employee_community_terms_of_uses.version))
        }, " Ver." + _toDisplayString(__props.data?.employee_community_terms_of_uses.version), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("label", _hoisted_10, _toDisplayString(_unref(translate)('OE30lastLogin')), 1),
      _createElementVNode("div", _hoisted_11, _toDisplayString(__props.data?.last_login ? _unref(ConvertFromLocalTime)(__props.data?.last_login) : ''), 1)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(translate)('SG41communityEmailNotice')), 1),
      _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(translate)(__props.data?.email_notice ? 'SG40receiveMail' : 'SG40notReceiveMail')), 1)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(Button, {
        title: _unref(translate)('back'),
        type: 'secondary',
        onClick: backToList
      }, null, 8, ["title"])
    ])
  ]))
}
}

})